import { render, staticRenderFns } from "./VerAsistencia.vue?vue&type=template&id=4ccbedd8&scoped=true"
import script from "./VerAsistencia.vue?vue&type=script&lang=js"
export * from "./VerAsistencia.vue?vue&type=script&lang=js"
import style0 from "./VerAsistencia.vue?vue&type=style&index=0&id=4ccbedd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccbedd8",
  null
  
)

export default component.exports